import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { FacilityService } from "../../../shared/services/facility.service";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	selector: "app-district-scan-station-tracking",
	templateUrl: "./district-scan-station-tracking.component.html",
	styleUrls: ["./district-scan-station-tracking.component.css"],
})
export class DistrictScanStationTrackingComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolService: SchoolService,
		private facilityService: FacilityService,
		private dialogService: DialogService
	) {}

	report = {
		//Insert Custom Parameters Here
		FacilityID: 0,
		SchoolID: 0,
		DecommissionedID: "All",
		StationFilter: "",
		SyncStatusID: "All",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	FacilityExtendedList: any = [];
	SchoolList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	DecommissionedList = [
		//Insert Custom List Items Here
		{
			DecommissionedName: "All",
		},
		{
			DecommissionedName: "Yes",
		},
		{
			DecommissionedName: "No",
		},
	];

	SyncStatusList = [
		//Insert Custom List Items Here
		{
			SyncStatusName: "All",
		},
		{
			SyncStatusName: "Never Synced",
		},
		{
			SyncStatusName: "Synced",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 418;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.loadFacilityExtendedList();
		// this.loadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.SchoolID = school.SchoolID;
			this.loadLogolist();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadFacilityExtendedList() {
		this.report.FacilityID = 0;
		var result = this.facilityService.loadFacilityList("");
		result.subscribe(
			(response) => {
				this.FacilityExtendedList = response;

				this.report.FacilityID = this.FacilityExtendedList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadSchoolList() {
		this.report.SchoolID = 0;
		var result = this.schoolService.GetSchoolsForUserReport(418);
		result.subscribe(
			(response) => {
				this.SchoolList = response;

				if (this.SchoolList.length > 1) {
					this.SchoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.SchoolList[0].SchoolID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.FacilityID) {
		//   this.errorMessage = "Select the Facility"
		//   return;
		// }

		// if (!this.report.SchoolID) {
		//   this.errorMessage = "Select the School"
		//   return;
		// }

		if (!this.report.DecommissionedID) {
			this.errorMessage = "Select the Decommissioned";
			return;
		}

		// if (!this.report.StationFilter) {
		//   this.errorMessage = "Select the StationFilter"
		//   return;
		// }

		if (!this.report.SyncStatusID) {
			this.errorMessage = "Select the Sync Status";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: FacilityIDExtended
		strParam += this.report.FacilityID + "|FacilityIDExtended";

		//Parameter 2: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 3: Decommissioned
		strParam += "," + this.report.DecommissionedID + "|Decommissioned";

		//Parameter 4: StationFilter
		strParam += "," + this.report.StationFilter + "|StationFilter";

		//Parameter 5: SyncStatus
		strParam += "," + this.report.SyncStatusID + "|SyncStatus";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
